import { useFetch as fetch } from 'qmai-ui/src/fetch'

// 获取账号类型
export function getAccountType() {
  return fetch({
    url: '/coroutine/picture/category/account-type',
    method: 'get',
  })
}

// 批量删除图片
export function delPictureByIds(data) {
  data._method = 'delete'
  return fetch({
    url: '/coroutine/picture/file/remove',
    method: 'post',
    data,
    headers: {
      'qm-seller-id': data.store_id || '',
    },
  })
}

// 获取相册分类列表
export function getAlbumCategory() {
  return getAccountType().then(typeRes => {
    // 集团用户
    if (typeRes.data.organizationType == 0) {
      return fetch({
        url: '/coroutine/picture/category/lists-v3',
        method: 'get',
      })
    } else {
      return fetch({
        url: '/coroutine/picture/category/lists-v2',
        method: 'get',
      })
    }
  })
}

// 相册分类添加
export function addAlbumCategory(data) {
  return fetch({
    url: '/coroutine/picture/category/create',
    method: 'post',
    data,
    headers: {
      'qm-seller-id': data.store_id || '',
    },
  })
}

// 相册分类名称修改
export function editAlbumCategoryById(data) {
  return fetch({
    url: '/coroutine/picture/category/editor',
    method: 'post',
    headers: {
      'qm-seller-id': data.store_id || '',
    },
    data,
  })
}

// 获取相册列表
export function getPictureList(data) {
  return fetch({
    url: '/coroutine/picture/file/lists',
    method: 'get',
    params: data,
    headers: {
      'qm-seller-id': data.store_id || '',
    },
  })
}

// 保存图片信息
export function editAlbumById(data) {
  return fetch({
    url: '/coroutine/picture/file/desc',
    method: 'post',
    data,
    headers: {
      'qm-seller-id': data.store_id || '',
    },
  })
}

// 上传图片
export function uploadImage(formData) {
  const { category_id: categoryId, store_id: storeId } = formData.data || formData

  const data = new FormData()
  data.append('upfile', formData.file)
  data.append('category_id', categoryId)
  return fetch({
    url: '/coroutine/picture/file/upload',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
      'qm-seller-id': storeId,
    },
    withCredentials: true,
    data,
  })
}

// 获取公共图库分类列表
export function getCommonAlbumCategory() {
  return fetch({
    url: '/coroutine/picture/common/cat-list-v2',
    method: 'get',
  })
}

// 获取相册列表
export function getCommonPictureList(data) {
  return fetch({
    url: '/coroutine/picture/common/file-list',
    method: 'get',
    params: data,
  })
}

// 删除相册分类名称
export function delAlbumCategoryId(data) {
  return fetch({
    url: '/coroutine/picture/category/Cate-Move',
    method: 'post',
    data,
    headers: {
      'qm-seller-id': data.store_id || '',
    },
  })
}

// 批量移动相册至目录名称
export function moveAlbumToCategory(data) {
  return fetch({
    url: '/coroutine/picture/file/Move',
    method: 'post',
    data,
    headers: {
      'qm-seller-id': data.store_id || '',
    },
  })
}

// 获取阿里云userId
export function getAliyunAuth() {
  return fetch({
    url: '/coroutine/video/config',
    method: 'get',
    skipErrorToast: true,
  })
}

// 获取视频目录列表
export function getVideoCategory() {
  return fetch({
    url: '/coroutine/video/category/lists-v2',
    method: 'get',
  })
}

// 获取视频列表
export function getVideoList(params) {
  return fetch({
    url: '/coroutine/video/file/lists',
    method: 'get',
    params,
  })
}

// 创建视频分组
export function addVideoCategory(pid, name) {
  const data = {
    pid,
    name,
  }
  return fetch({
    url: '/coroutine/video/category/create',
    method: 'post',
    data,
  })
}

/**
 * 根据ID删除视频分组
 * *如果分组下含有信息，则删除失败
 * @param {*分组ID} id
 */
export function delVideoCategoryById(id) {
  const data = {
    _method: 'delete',
    id: id,
  }
  return fetch({
    url: '/coroutine/video/category/remove',
    method: 'post',
    data,
  })
}

// 获取视频上传地址和凭证
export function creatVideo(data) {
  return fetch({
    url: '/coroutine/video/create-upload',
    method: 'post',
    data,
  })
}

// 获取视频封面
export function getVideoCover(data) {
  return fetch({
    url: '/coroutine/video/info',
    method: 'get',
    params: data,
  })
}

// 添加视频
export function addVideo(data) {
  return fetch({
    url: '/coroutine/video/file/add',
    method: 'post',
    data,
  })
}

// 获取视频播放地址
export function getVideoInfo(videoId) {
  return fetch({
    url: '/coroutine/video/mezzanine-info',
    method: 'get',
    params: {
      video_id: videoId,
    },
  })
}

// 编辑视频信息
export function editVideoDetail(data) {
  return fetch({
    url: '/coroutine/video/file/update',
    method: 'post',
    data,
  })
}

// 删除视频
export function removeVideo(ids) {
  const data = {
    _method: 'delete',
    ids: ids,
  }
  return fetch({
    url: '/coroutine/video/file/batch-remove',
    method: 'post',
    data,
  })
}

// 根据ID修改视频分组名称
export function editVideoCategoryById(id, newName) {
  const data = {
    id,
    new_name: newName,
  }
  return fetch({
    url: '/coroutine/video/category/update',
    method: 'post',
    data,
  })
}

// 批量移动相册至目录名称
export function moveVideoToCategory(data) {
  return fetch({
    url: '/coroutine/video/file/Move',
    method: 'post',
    data,
  })
}

// 删除视频分类名称
export function delVideoCategoryId(data) {
  return fetch({
    url: '/coroutine/video/category/Cate-Move',
    method: 'post',
    data,
  })
}
